<app-modal-v2 #modal>
  <div class="modal-header">
    <h2 class="modal-title">Set Patient Password</h2>

    <div class="modal-actions">
      <button class="btn btn-primary" [disabled]="form.invalid" (click)="onFormSubmit()">
        <span *ngIf="form.get('isBusy').value">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </span>
        <span *ngIf="!form.get('isBusy').value">Set Password</span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" class="form-control" id="password" placeholder="Enter new password..." formControlName="password">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="confirm-password">Confirm Password</label>
            <input type="password" class="form-control" id="confirm-password" placeholder="Confirm new password..." formControlName="confirmPassword">

            <span class="validation-error" *ngIf="form.get('confirmPassword')?.errors?.passwordMismatch && (form.get('confirmPassword')?.dirty || form.get('confirmPassword')?.touched)">
              The passwords entered do not match
            </span>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <div class="checkbox-wrap">
              <label class="checkbox">
                <input type="checkbox" id="confirmed" formControlName="confirmed">
                <span></span>
              </label>
              <label class="checkbox-label" for="confirmed">
                I confirm I’m resetting the password for the intended patient and understand they can’t log in until they receive this new password.
              </label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</app-modal-v2>
